import '../../styles/index.scss';
import { docReady } from '../helpers/docReady';
import header from '../sections/header';
import initMinitCart from './mini-cart';
docReady(() => {
    // console.log('Cardigang: Custom JS Loaded');
    header();
    initMinitCart();
});
